export default "__VITE_ASSET__DxlqsX_e__"